import React from 'react';

const CommonSectionArea = ({ area_header }) => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 col-lg-5">
                     {area_header}
                  </div>
                  <div className="col-xl-6 col-lg-7">
                     <div className="about-right-side pt-55 mb-30">
                        <div className="about-title mb-20">
                           <h5>About Us</h5>
                           <h1>Short Story About Octavia Hospitals.</h1>
                        </div>
                        <div className="about-text mb-50">
                           <p>
                              Octavia Hospital is established by Eight Lions Hospital Pvt. Ltd. which was incorporated on 14 July 2016 under the Companies Act, 2013. Eight Lions Hospital Pvt. Ltd. has emerged as foremost Octavia Hospital integrated health care services provider and has arobust presence across the healthcare ecosystem, including Hospital, Pharmacies, Tertiary Care, Emergency & Diagnostic services.
                              <br />
                              The cornerstones of Eight Lions legacy are its unstinting focus on clinical excellence, affordable costs, modern technology & seamless quality healthcare delivery. As a responsible corporate citizen, Eight Lions Hospitals takes the spirit of leadership well beyond business and has embraced the responsibility of keeping India healthy.
                           </p>
                        </div>
                        <div className="our-destination">
                           <div className="single-item mb-30">
                              <div className="mv-icon f-left">
                                 <img src="img/about/destination-icon-1.png" alt="" />
                              </div>
                              <div className="mv-title fix">
                                 <h3>Our Mission</h3>
                                 <p>
                                    "Improving lives by providing comprehensive quality health care services under one roof through transparent patient - centric care andat affordable prices. An institution where Every Life Indeed Matters."
                                 </p>
                              </div>
                           </div>
                           <div className="single-item">
                              <div className="mv-icon f-left">
                                 <img src="img/about/destination-icon-2.png" alt="" />
                              </div>
                              <div className="mv-title fix">
                                 <h3>Our Vision</h3>
                                 <p>
                                    "We aim to be a global healthcare institution where we bring people together to provide compassionate Care, promote health and create healthy communities.
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default CommonSectionArea;